function createFilter(attributesObj) {
  const keys = Object.keys(attributesObj);
  const result = keys
    .filter(
      (key) =>
        key !== 'remoteEnabled' &&
        attributesObj[key].values &&
        attributesObj[key].values.length
    )
    .reduce((acc, el) => ({ ...acc, [el]: attributesObj[el].values }), {});

  if (Object.keys(result).length === 0) {
    return undefined;
  }
  return result;
}
function createRemotly(attributesObj) {
  if (
    attributesObj.remoteEnabled &&
    attributesObj.remoteEnabled.values &&
    attributesObj.remoteEnabled.values.length === 1
  ) {
    return attributesObj.remoteEnabled.values[0];
  }
  return undefined;
}
export default ({ pageSize, page, globalSearch, entities, attributesObj }) => {
  const entitiesFilters = entities.map((el) => el.nav_full_id);
  return {
    // Object.assign allow to put attribute in object according to condition
    query: Object.assign(
      {
        limit: pageSize,
        page,
        entities: entitiesFilters,
        filters: createFilter(attributesObj),
        remotly: createRemotly(attributesObj),
      },
      globalSearch && {
        globalSearch,
        likes: ['code', 'shortname', 'name', 'city', 'postal_code', 'street'],
      }
    ),
  };
};
